<template>
	<div v-if="visible" class="modal-overlay" @click.self="close">
		<div class="modal">
			<h3 style="margin-bottom: 6px">{{ store.errorDialog.title }}</h3>
			<p
				v-if="store.errorDialog.messages?.length"
				v-for="message of store.errorDialog.messages"
			>
				{{ message }}
			</p>
			<div style="display: flex; flex-direction: row-reverse; gap: 8px; margin-top: 12px">
				<button @click="$emit('close')">{{ $t("panels.errorDialog.closeButton") }}</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useMainStore } from "@/store/mainStore";

defineProps({
	visible: Boolean,
});

const store = useMainStore();

const emit = defineEmits(["close"]);
</script>
